import AuthButton from './AuthButton';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from '../hooks/useTranslation';

export default function AuthButtons({ setLoading, setError, signup = false }) {
    const { googleLogin, microsoftLogin } = useAuth();
    const t = useTranslation();

    return (
        <>
            <AuthButton type="google" setLoading={setLoading} setError={setError} loginCallback={googleLogin} signup={signup}>{signup ? t('Sign Up with Google') : t('Sign In with Google')}</AuthButton>
            <AuthButton type="microsoft" setLoading={setLoading} setError={setError} loginCallback={microsoftLogin}>{signup ? t('Sign Up with Microsoft') : t('Sign In with Microsoft')}</AuthButton>
            {/*<AuthButton type="apple" setLoading={setLoading} setError={setError} loginCallback={appleLogin}>{signup ? t('Sign Up with Apple') : t('Sign In with Apple')}</AuthButton>*/}
        </>

    )
}

